import { useEffect, useState } from "react";
import { _ImportRegistry, _single } from "../../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../../core/services/dataBean/useDataBean"
import { BasicPage } from "../../theme/Component/BasicPage"
import { PrintJson } from "../../theme/Component/PrintJson";
import { BasicTable, MASK_DATE } from "../../theme/Component/BasicTable";
import { ListMenu } from "../../theme/Component/ListMenu";
import useModal, { MODAL_LG, MODAL_md, MODAL_SM } from "../../theme/Component/hooks/useModal";
import { Modal } from "../../theme/Component/Modal";
import { InputDate } from "../../theme/Input/InputDate";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import usePaginator from "../../theme/Component/usePaginator";
import { YearSelector } from "../../../core/shared/inputs/YearSelector";
import { BasicButton } from "../../theme/Component/BasicButton";
import { ImportRegistryItem } from "./ImportRegistryItem";
import { toast } from "react-toastify";
import { EditorExpedientDocumentFile } from "../../DocumentManagement/Management/DocumentFileManager/EditorExpedientDocumentFile";

interface Props {
    idSelector?: number;
    editor?: boolean;
    onChange?: any;
    label?: string;
}

export const ImportRegistry = ({ idSelector, editor = false, onChange, label }: Props) => {


    const _importRegistry = useDataBean(_ImportRegistry);
    const { bean, setBean, lista, setLista, instance, handleChange } = _importRegistry;
    const formType = [
        { id: 100, name: 'Contrato' },
        { id: 200, name: 'Donación' }
    ];
    const [filter, setFilter] = useState({
        Year: _single.getCurrenYear(),
        TypeRegister: 100,
        State: 1,
        ContractNumber: null
    })
    const modalEdit = useModal("Editar", MODAL_LG);
    const modalDel = useModal("Eliminar", MODAL_SM);
    const modalItems = useModal("Items", MODAL_LG);
    const modalSelect = useModal("Seleccionar registro", MODAL_LG);
    const modalExpedient = useModal("Expediente del registro", MODAL_LG);
    const paginador = usePaginator();

    useEffect(() => {
        if (idSelector && idSelector != bean.IDImportRegistry) {
            instance.getImportRegistry(idSelector).then(
                (resp) => {
                    setBean(resp);
                }
            ).catch(err => { toast.error(err) })
        }
    }, [idSelector])

    useEffect(() => {
        getImportRegistry();
    }, [filter.TypeRegister, paginador.page]);

    useEffect(() => {
        if (onChange) {
            onChange(bean);
            modalSelect.close();
        }
    }, [bean])

    const getImportRegistry = () => {
        instance.getImportRegistryRender(filter.TypeRegister, paginador.page, 15, _single.cleanMap(filter)).then(
            (resp: any) => {

                setLista(resp.List);
                paginador.setPages(resp.NumberOfPages);
            }
        )
    }




    const addItem = () => {
        setBean({
            IDEmployee: _single.getAccountID(),
            State: 1,
            TypeRegister: filter.TypeRegister
        });
        modalEdit.open();
    }


    const head = [
        { title: 'No', property: 'ContractNumber' },
        { title: 'Nombre', property: 'CompanyName' },
        { title: 'Objecto / Descripción', property: 'ContractObject' },
        { title: 'Fecha', property: 'RegisterDate', mask: MASK_DATE },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: () => { addItem() } }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-file-list-line', visible: _single.canEdit(), evento: () => { modalEdit.open() } },
            { titulo: 'Items', icono: 'ri-list-unordered', visible: _single.canEdit(), evento: () => { modalItems.open() } },
            { titulo: 'Expediente del registro', icono: 'ri-folder-5-line', visible: true, evento: () => { modalExpedient.open() } },
            { titulo: 'Eliminar', icono: 'ri-file-user-line', visible: _single.canDelete(), evento: () => { modalDel.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const edit = () => {
        console.log(bean);
        _ImportRegistry.updateCustonBean(bean).then(
            (resp: any) => {
                getImportRegistry();
                modalEdit.close();
            }
        )

    }
    const delItem = () => {
        _importRegistry.deleteItem(bean.IDImportRegistry).then(
            (resp: any) => {
                getImportRegistry();
                modalDel.close();
            }
        )
    }

    const renderComponente = () => {
        return (
            <>
                <div className="row">
                    <div className="col-md-3">
                        <label>Año</label>
                        <YearSelector value={filter.Year} onChange={(e) => setFilter({ ...filter, Year: e })} />
                    </div>
                    <div className="col-md-4">
                        <label>Tipo de Registro</label>
                        <select className="form-select" value={filter.TypeRegister} onChange={(e) => setFilter({ ...filter, TypeRegister: parseInt(e.target.value) })}>
                            {formType.map((item: any) => {
                                return (
                                    <option key={item.id} value={item.id}>{item.name}</option>
                                )
                            })}
                        </select>
                    </div>
                    <div className="col-md-5">
                        <label>No. Contrato</label>
                        <input type="text" className="form-control" name="ContractNumber" value={filter.ContractNumber} onChange={(e) => { setFilter({ ...filter, ContractNumber: e.target.value }) }} />
                    </div>
                    <div className="col-md-4">
                        <BasicButton useMargin icon="" eventClick={getImportRegistry}>Buscar</BasicButton>
                    </div>
                    <div className="col-md-12">
                        <BasicTable body={lista} head={head} rowSet={setBean} iconButtons={iconButtonsItem} listButtons={editor ? null : listaBotones()} records={paginador}></BasicTable>
                        <Modal modal={modalEdit.modal} updateModal={modalEdit.setModal} eventModal={edit}>
                            <div className="row">
                                <div className="col-md-6">
                                    <label>No. Contrato / Convenio</label>
                                    <input type="text" className="form-control" name="ContractNumber" value={bean.ContractNumber} onChange={handleChange} />
                                </div>
                                <div className="col-md-6">
                                    <label>Empresa</label>
                                    <input type="text" className="form-control" name="CompanyName" value={bean.CompanyName} onChange={handleChange} />
                                </div>
                                <div className="col-md-6">
                                    <InputDate name="RegisterDate" label="Fecha" value={bean.RegisterDate} onChangeE={(e) => { setBean({ ...bean, "RegisterDate": e }) }} />
                                </div>
                                <div className="col-md-6">
                                    <label>Inconterms</label>
                                    <input type="text" className="form-control" name="Incoterms" value={bean.Incoterms} onChange={handleChange} />
                                </div>
                                <div className="col-md-12">
                                    <label>Objecto / Descripción</label>
                                    <textarea name="ContractObject" className="form-control" value={bean.ContractObject} onChange={handleChange}></textarea>
                                </div>

                            </div>
                        </Modal>
                        <Modal modal={modalItems.modal} updateModal={modalItems.setModal}>
                            <div className="row">
                                <div className="col-md-12">
                                    <ImportRegistryItem importRegistry={bean} />
                                </div>
                            </div>
                        </Modal>
                        <ModalConfirm modal={modalDel.modal} updateModal={modalDel.setModal} eventModal={delItem}>
                            <div className="row">
                                <div className="col-md-12">
                                    Eliminar registro ?
                                </div>
                            </div>
                        </ModalConfirm>

                        <Modal modal={modalExpedient.modal} updateModal={modalExpedient.setModal}>
                            <EditorExpedientDocumentFile _ClassForName="com.orange.finance.processcontract.bean.ImportRegistry" _IDClass={bean.ImportRegistry} />
                        </Modal>

                    </div>
                    <div className="col-md-12">
                        {/* <PrintJson json={lista}/> */}
                    </div>

                </div>
            </>
        )
    }

    return (
        <>
            {!editor ?
                <BasicPage titulo="Registro de Importación">
                    {renderComponente()}
                </BasicPage>
                :
                <>
                    {(!label || label != " ") &&
                        < label > Contrato / Donacion</label>
                    }
                    <input type="text" className="form-control" readOnly value={bean.ContractNumber} onClick={() => { modalSelect.open() }} />
                    <Modal modal={modalSelect.modal} updateModal={modalSelect.setModal} >
                        <div className="row">
                            <div className="col-md-12">
                                {renderComponente()}
                            </div>
                        </div>
                    </Modal>
                </>
            }
        </>
    )
}